import { Suspense, useContext, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './style/animations.css';
import './style/main.css';
import './style/reset.css';
import './style/variables.css';


import { CircularProgress } from '@mui/material';
import routes from 'routes/routes';
import { AuthContext } from "./features/auth/store/auth.provider";

import LoginPage from 'features/auth/pages/Login';
import Layout from 'layout/Layout';

const loading = (
  <div className="pt-3 text-center">
    <CircularProgress />
  </div>
)

const App = () => {
  const auth = useContext<any>(AuthContext);
  useEffect(() => {
    localStorage.setItem("initial_query", window.location.search);
    return () => {
      localStorage.setItem("initial_query", "");
    }
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route, idx) => {
          return route.component && (
            <Route key={idx} path={route.path} element={
              <div className="fade">
                {
                  route.requiredLogin ?
                    auth.user?._id ?
                      <Layout>
                        <Suspense fallback={loading}>
                          <route.component />
                        </Suspense>
                      </Layout>
                    :
                      <LoginPage />
                  :
                    <Layout>
                      <Suspense fallback={loading}>
                        <route.component />
                      </Suspense>
                    </Layout>
                }
              </div>
            } />
          )
        })}
      </Routes>
    </BrowserRouter>
  );
}
export default App;
